import { render, staticRenderFns } from "./ApprovalView.vue?vue&type=template&id=028ffb51"
import script from "./ApprovalView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApprovalView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports